import { cn } from '@utils/cn';
import React from 'react';
import { MaterialSource } from '@models/warehouse.model';

interface SourceBadgeProps {
  source: MaterialSource;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const SourceBadge: React.FC<SourceBadgeProps> = ({
  source,
  size = 'md',
  className = '',
}) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs h-5',
    md: 'px-3 py-1 text-sm h-6',
    lg: 'px-4 py-1.5 text-base h-8',
  };

  const sourceConfig = {
    [MaterialSource.WAREHOUSE]: {
      label: 'Warehouse',
      classes: 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
      dotColor: 'bg-green-500',
    },
    [MaterialSource.MANUAL]: {
      label: 'Manual',
      classes: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100',
      dotColor: 'bg-gray-500',
    },
  };

  const config = sourceConfig[source];
  const baseClasses =
    'inline-flex items-center justify-center gap-1.5 rounded-full font-medium whitespace-nowrap w-fit';

  return (
    <span className={cn(baseClasses, sizeClasses[size], config.classes, className)}>
      <span className={cn('w-2 h-2 rounded-full', config.dotColor)} />
      {config.label}
    </span>
  );
};
